"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var HealthNeedsModule_1 = require("../components/HealthNeedsModule/HealthNeedsModule");
var targetNode = document.querySelector('.health-needs-module-section');
if (targetNode) {
    (0, preact_1.render)((0, preact_1.h)(HealthNeedsModule_1.default, null), targetNode);
}
